import validatorBuilder from 'validator-builder';

let imageCaracteristiquesValidator = null;

export default class ImageCaracteristiques {
    constructor(data) {
        imageCaracteristiquesValidator = imageCaracteristiquesValidator || validatorBuilder.getInstanceFor('ImageCaracteristiques');
        imageCaracteristiquesValidator.clearRules();
        imageCaracteristiquesValidator.generateRules();

        this.data = {};
        for (const element in data) {
            if (element !== 'data') {
                this[element] = data[element];
                this.data[element] = {
                    id: parseInt(element),
                    value: getFormattedValues(data[element]),
                    additionalInformations: { key: 'clé', value: 'valeur' }
                };
            }
        }

        function getFormattedValues(element) {
            if (Array.isArray(element)) {
                const result = _.map(element, function (e) {
                    if (e && e.hasOwnProperty('key')) {
                        return { value: e.key };
                    }
                    return { value: e };
                });
                return result;
            }
            return element;
        }
    }

    isValid() {
        const validationResults = imageCaracteristiquesValidator.validate(this);
        return validationResults.isValid;
    }
}
